import styled from 'styled-components';

const StyledContainer = styled.div`
	margin-top: 20px;
	transition: opacity 0.3s ease;

	&.apps-enter {
		opacity: 0;
	}

	&.apps-enter-active,
	&.apps-enter-done,
	&.apps-exit {
		opacity: 1;
	}

	&.apps-exit-active {
		opacity: 0;
	}
`;

export { StyledContainer };
